
import { Link } from "react-router-dom";
import { Button, Grid, TextField, Typography } from "@mui/material";
import { useForm } from "../../../hooks";
import { InputDePassword } from "../../home/components";
import { useAuthStore } from "../../../stores/usuarios/auth.store";


import Swal from 'sweetalert2';
const empresa = require.context('../../../assets/empresa', true);





export const LoginSuperAdmin = () => {


    const { startLoginUser } = useAuthStore();
    const [ formAdmin, handleInputChangeA ] = useForm({ movil: '', password: '' });
    const { movil, password } = formAdmin;



    const handleLogin = (e) => {
        e.preventDefault();
        if (!movil?.trim() || !password?.trim()) {
            Swal.fire('Error', 'La cédula y la contraseña son obligatorias.', 'error');
            return;
        }
        startLoginUser({ movil, password })
    }



    return (

        <Grid container className="login-cliente">
            <Grid item className="img-cliente">
                <img src={ empresa(`./svtextoblanco.png`) } />
            </Grid>

            <Grid item>
                <Typography variant="h1" mt={3}>Login Admin</Typography>
            </Grid>

            <Grid item xs={10} sx={{ width:'400px', padding:'20px' }}>
                <form onSubmit={ handleLogin } autoComplete="off" >

                    <Grid item xs={12} mt={2} >
                        <TextField required
                            label='Numero Telefono'
                            type='text'
                            placeholder='Numero Telefono'
                            fullWidth
                            name="movil" 
                            value={ movil }
                            onChange={ handleInputChangeA }
                        />
                    </Grid>


                    <Grid item xs={12} mt={ 2 }>
                        <InputDePassword value={password}
                            name='password'
                            placeholder={'Password'} 
                            onChangeInput={ handleInputChangeA } 
                        /> 
                    </Grid>

                    <Grid container my={3} direccion='column' justifyContent='center'  >
                        <Grid item xs={ 12 } >
                            <Button variant="contained" color="primary" fullWidth type="submit" >
                                <Typography variant="span" color='white' >Ingresar</Typography>
                            </Button>
                        </Grid>
                    </Grid>

                </form>

                <Grid sx={{ width: "100%", display: "flex", justifyContent: "flex-end" }}>
                    <Typography component={Link} to="/admin/olvide-password"
                        sx={{ textDecoration:"none", fontSize:"0.95rem", fontWeight:500, color:"text.secondary",
                        transition:"all 0.2s ease","&:hover": { color:"secondary.main", transform:"translateY(-1px)" }
                    }}>
                        Olvidé mi contraseña
                    </Typography>
                </Grid>
            </Grid>

        </Grid>

    )
}
